import { List } from 'immutable';
import _ from 'lodash';

import {
    DUPLICATED_GROUP,
    DUPLICATED_USER,
    INTERNAL_SERVER_ERROR,
    MISSING_GROUP_ENTITY,
    MISSING_USER_ENTITY,
    NOT_FOUND_USER_ENTITY,
    PERMISSION_PARENT_EXISTS,
    VALIDATION_BODY_MALFORMED,
    VALIDATION_EMPTY_ASSIGNMENT_BODY,
    VALIDATION_PAST,
    VALIDATION_PATTERN,
    VALIDATION_REQUIRED,
    VALIDATION_SIZE,
} from './ErrorCode';

interface ErrorDefinition {
    errorCode: string;
    message: string;
}

const defaultErrorDefinition: ErrorDefinition = {
    errorCode: 'unknown.error',
    message: 'text:Unknown.Error',
};

const errorDefinitionsPool: List<ErrorDefinition> = List.of(
    {
        errorCode: VALIDATION_SIZE,
        message: 'The %s field is incorrect. Please enter at least %s and at most %s characters.',
    },
    {
        errorCode: VALIDATION_REQUIRED,
        message: 'The %s field is required.',
    },
    {
        errorCode: VALIDATION_PAST,
        message: 'The %s field cannot be in the past',
    },
    {
        errorCode: VALIDATION_BODY_MALFORMED,
        message: 'Oops, something went wrong. Please try again later',
    },
    {
        errorCode: VALIDATION_PATTERN,
        message: 'The %s field is incorrect. Please enter the value that complies with %s pattern.',
    },
    {
        errorCode: MISSING_USER_ENTITY,
        message: 'User is missing',
    },
    {
        errorCode: NOT_FOUND_USER_ENTITY,
        message: 'User does not exist',
    },
    {
        errorCode: MISSING_GROUP_ENTITY,
        message: 'Group does not exist',
    },
    {
        errorCode: DUPLICATED_USER,
        message: 'User already exist',
    },
    {
        errorCode: DUPLICATED_GROUP,
        message: 'Group you want to save already exists',
    },
    {
        errorCode: PERMISSION_PARENT_EXISTS,
        message:
            "Can't create permission, there exists illegal partnership. You cannot create permission xx.yy.cc when permission xx.yy exists and other way around.",
    },
    {
        errorCode: VALIDATION_EMPTY_ASSIGNMENT_BODY,
        message: 'Empty assignments',
    },
    {
        errorCode: INTERNAL_SERVER_ERROR,
        message: 'Oops, something went wrong. Please try again later',
    },
);

export const getErrorDefinition = (code: string) => {
    const errorDefinition = errorDefinitionsPool.filter((ed) => ed.errorCode === code).first();
    return _.defaultTo(errorDefinition, defaultErrorDefinition);
};
